var map = {
	"./banner-new.png": 1063,
	"./card-bg-1.png": 1132,
	"./card-bg-2.png": 1133,
	"./card-bg-3-old.png": 1134,
	"./card-bg-3.png": 1135,
	"./card-bg-small.png": 1136,
	"./coupon-icon.png": 1137,
	"./genshin/button-bg.png": 1138,
	"./genshin/coupon.png": 1031,
	"./genshin/coupon_bg.png": 1139,
	"./genshin/coupon_bg_popup_1.png": 1140,
	"./genshin/coupon_bg_popup_2.png": 1141,
	"./genshin/gift_bg.png": 1142,
	"./genshin/gift_bg_popup_1.png": 1143,
	"./genshin/gift_bg_popup_2.png": 1144,
	"./genshin/kGold.png": 1030,
	"./genshin/popup-bg-1.png": 1145,
	"./genshin/popup-bg-2.png": 1146,
	"./genshin/popup-bg-invited.png": 1147,
	"./genshin/popup-bg_GT.png": 1148,
	"./genshin/popup-btn-guest-login.png": 1149,
	"./genshin/popup-btn-guest.png": 1150,
	"./genshin/popup-btn-owner.png": 1151,
	"./icon/award__coupon.png": 1009,
	"./icon/coupon-new.png": 1023,
	"./icon/coupon.png": 1008,
	"./icon/facebook.png": 1060,
	"./icon/gift.png": 1041,
	"./icon/google.png": 1061,
	"./icon/kgold-new.png": 1024,
	"./icon/kgold.png": 999,
	"./icon/score-icon.png": 1015,
	"./icon/uc-new.png": 1025,
	"./mlbb-banner.png": 1093,
	"./mlbb.png": 1152,
	"./mobile-legends/award.png": 1153,
	"./mobile-legends/button-bg.png": 1154,
	"./mobile-legends/coupon-icon.png": 1155,
	"./mobile-legends/coupon_bg.png": 1071,
	"./mobile-legends/coupon_bg_popup_1.png": 1156,
	"./mobile-legends/coupon_bg_popup_2.png": 1157,
	"./mobile-legends/gift_bg.png": 1072,
	"./mobile-legends/gift_bg_popup_1.png": 1158,
	"./mobile-legends/gift_bg_popup_2.png": 1159,
	"./mobile-legends/payment-award__sku.png": 1160,
	"./mobile-legends/popover-coupon-icon.png": 1029,
	"./mobile-legends/popup-bg-1.png": 1161,
	"./mobile-legends/popup-bg-2.png": 1162,
	"./mobile-legends/popup-bg-invited.png": 1163,
	"./mobile-legends/popup-bg_GT.png": 1164,
	"./mobile-legends/popup-btn-guest.png": 1165,
	"./mobile-legends/popup-btn-owner.png": 1166,
	"./mobile-legends/register-award__sku.png": 1167,
	"./mobile-legends/score-icon.png": 1064,
	"./mobile-legends/sku-icon.png": 1168,
	"./parachute.png": 1073,
	"./pubgm/award-bg.png": 1169,
	"./pubgm/award-icon-1.png": 1170,
	"./pubgm/award__sku.png": 1171,
	"./pubgm/big-sku-icon.png": 1172,
	"./pubgm/button-bg.png": 1173,
	"./pubgm/coupon-icon.png": 1174,
	"./pubgm/coupon-sharee-bg.png": 1175,
	"./pubgm/coupon-sharer-bg.png": 1176,
	"./pubgm/coupon_bg.png": 1177,
	"./pubgm/coupon_bg_popup_1.png": 1178,
	"./pubgm/coupon_bg_popup_2.png": 1179,
	"./pubgm/gift_bg.png": 1180,
	"./pubgm/gift_bg_popup_1.png": 1181,
	"./pubgm/gift_bg_popup_2.png": 1182,
	"./pubgm/login-btn-new.png": 1183,
	"./pubgm/popover-coupon-icon.png": 1005,
	"./pubgm/popup-bg-1.png": 1184,
	"./pubgm/popup-bg-2.png": 1185,
	"./pubgm/popup-bg-bottom.png": 1186,
	"./pubgm/popup-bg-invited.png": 1187,
	"./pubgm/popup-bg_GT.png": 1188,
	"./pubgm/popup-btn-guest.png": 1189,
	"./pubgm/popup-btn-owner.png": 1190,
	"./pubgm/popup-top-icon.png": 1191,
	"./pubgm/pubgm-bg.png": 1192,
	"./pubgm/pubgm-personage.png": 1032,
	"./pubgm/score-icon.png": 1065,
	"./pubgm/sku-icon.png": 1193,
	"./pubgm/small-coupon-icon.png": 1194,
	"./pubgm/small-sku-icon.png": 1195,
	"./pubgm/toplupe-pubgm.png": 1033,
	"./score-bg.png": 1196,
	"./submit-bg.png": 1197,
	"./tip-bg.png": 1198,
	"./user-bg.png": 1062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1584;